import { LoyaltyConfig } from '../types';

export const defaultLoyaltyConfig: LoyaltyConfig = {
  fullShop: false,
  loggedOutCmsHomePage: false,
  profileRank: false,
  shop: false,
};
